"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleToString = void 0;
const variantsPropertyMap = {
    filled: {
        properies: ["fill"],
        blacklist: ["stroke"]
    },
    outlined: {
        properies: ["stroke"],
        blacklist: ["fill"]
    },
    full: {
        properies: ["fill", "stroke"],
        blacklist: []
    }
};
const styleToString = (variant, { color, ...styles }) => {
    const { properies } = variantsPropertyMap[variant];
    properies.forEach((property) => {
        styles[property] = color || styles[property];
    });
    return `{ ${Object.entries(styles)
        .filter(([key]) => !variantsPropertyMap[variant].blacklist.includes(key))
        .map(([key, value]) => `${key}:${value};`)
        .join("")} }`;
};
exports.styleToString = styleToString;
